// eslint-disable-next-line import/prefer-default-export
export const CHATGROUPREQUESTS_SELECTOR_KEY = 'chatgroups/requests';
export const CHATGROUPREQUESTS_BY_CHATGROUP_SELECTOR_KEY = 'chatgroups/requests/byChatgroupId';

export const CHATGROUPREQUESTS_STATE_ACCEPTED = 'accepted';
export const CHATGROUPREQUESTS_STATE_REJECTED = 'rejected';
export const CHATGROUPREQUESTS_STATE_CREATED = 'created';
